import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { ERROR_LINK } from 'utils/redirects';
import buildTestClient from './build.test.gql.client';

const TAXI_GRAPHQL_FORM_ROOT = '/api/v1/form';

const httpLink = createHttpLink({
  uri: TAXI_GRAPHQL_FORM_ROOT,
  credentials: 'same-origin',
});
const link = ERROR_LINK.concat(httpLink);

export default function getClient() {
  if (process.env.NODE_ENV && process.env.NODE_ENV === 'test') {
    return buildTestClient();
  }
  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
}
